import { Button } from 'antd';

interface UpdateButtonProps {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export const UpdateButton = ({
  onClick,
  loading = false,
  disabled = false,
}: UpdateButtonProps) => (
  <div
    style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '36px',
    }}
  >
    <Button
      type='primary'
      data-testid='Analytics-Update_Button'
      disabled={disabled || loading}
      loading={loading}
      onClick={onClick}
      style={{ width: '90px', height: '36px' }}
    >
      Update
    </Button>
  </div>
);
